module.exports = "https://web-assets.ifttt.com/packs/media/shared/favicon-cb369cca.ico";